export default "__VITE_ASSET__dNSs1zzS__"